<template>
  <div class="c-content-detail">
    <list-detail-header  :columns="detailConfig.listDetailColumns"/>
    <list-detail-content  :columns="detailConfig.listDetailColumns"  :contentData="listDetailDate" :isContentLoading="isContentLoading"/>
  </div>
</template>
<script>
import {
  defineComponent, inject, computed, watch, ref, provide,
} from 'vue';
import { useRoute } from 'vue-router';
import ListDetailHeader from '@/components/MyMusic/MyMusicList/ListDetail/ListDetailHeader.vue';
import ListDetailContent from '@/components/MyMusic/MyMusicList/ListDetail/ListDetailContent.vue';
import { getAccountPlaylistAPI } from '@/api/myMusicPlaylists';
import useRequest from '@/hooks/useRequest';
// import imageSource from '@/utils/imageSource';
import usePopInfo from '@/hooks/usePopInfo';
import { getSearchAlbumAPI } from '@/api/getAlbums';
import { getSearchPlaylistAPI } from '@/api/getPlaylists';
// import { useCacheStore } from '@/store/cache';
// import { searchTracksByUidAPI } from '@/api/getTags';
// import { useSiteStore } from '@/store/site';
import { useMyMusicStore } from '@/store/myMusic';
import useTrackTags from '@/hooks/useTrackTags';

export default defineComponent({
  name: 'ContentDetail',
  components: {
    ListDetailHeader,
    ListDetailContent,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

  },
  setup(props) {
    const route = useRoute();
    const myMusicStore = useMyMusicStore();
    // const cacheStore = useCacheStore();
    const { handleTrackTags } = useTrackTags();
    const { errorPopInfo } = usePopInfo();
    const { request, response } = useRequest(getSearchAlbumAPI);
    const { request: getPlaylistReq, response: getPlaylistRes } = useRequest(getSearchPlaylistAPI);
    const { request: getAccountPlaylistReq, response: getAccountPlaylistRes } = useRequest(getAccountPlaylistAPI);
    // const { request: searchTracksUidRequest } = useRequest(searchTracksByUidAPI);

    const listDetailDate = ref([]);
    const isContentLoading = ref(false);
    // const tagsUidKeys = computed(() => cacheStore.tagsUidKeys);
    const listFilter = computed(() => myMusicStore.listFilter.includes('tags'));

    const callApi = () => {
      isContentLoading.value = true;
      if (route.name === 'my-music-playlists') {
        getAccountPlaylistReq({
          in: props.data?.accountPlaylistUid,
        });

        return;
      }

      if (route.name === 'search' && route.query.type === 'playlists') {
        getPlaylistReq({
          in: props.data?.playlistUid,
        });

        return;
      }

      request({ in: props.data?.albumUid });
    };

    callApi();

    provide('reloadPlaylistContent', callApi);

    watch(response, () => {
      isContentLoading.value = false;
      const [err, res] = response.value;

      if (err) {
        errorPopInfo({
          desc: err,
        });
        return;
      }

      listDetailDate.value = (res.getAlbum.tracks || []).map((item) => ({
        ...item,
        albumUid: props.data?.albumUid,
      }));

      if (listFilter.value) {
        // handleFetchTags();
        handleTrackTags(listDetailDate.value);
      }
    });

    watch(getPlaylistRes, () => {
      isContentLoading.value = false;
      const [err, res] = getPlaylistRes.value;

      if (err) {
        errorPopInfo({
          desc: err,
        });

        return;
      }

      listDetailDate.value = (res.getPlaylist.tracks || []).filter((item) => item.track).map((item) => ({
        ...item,
        playlistUid: props.data?.playlistUid,
      }));

      if (listFilter.value) {
        // handleFetchTags();
        handleTrackTags(listDetailDate.value);
      }
    });

    watch(getAccountPlaylistRes, () => {
      isContentLoading.value = false;
      const [err, res] = getAccountPlaylistRes.value;

      if (err) {
        errorPopInfo({
          desc: err,
        });

        return;
      }

      const playlistData = res.getAccountPlaylist?.accountPlaylistContents.map((item) => ({
        accountPlaylistUid: res.getAccountPlaylist.accountPlaylistUid,
        ...item,
      }));

      listDetailDate.value = playlistData || [];
    });

    const detailConfig = computed(() => {
      try {
        return inject('detailConfig')();
      } catch {
        return ({
          listDetailColumns: [],
          listDetailContentData: [],
        });
      }
    });

    watch(listFilter, (newVal) => {
      if (newVal) {
        // handleFetchTags();
        handleTrackTags(listDetailDate.value);
      }
    });

    return {
      detailConfig,
      listDetailDate,
      isContentLoading,
    };
  },
});
</script>
<style lang="scss" scoped>

</style>
